import Model  from '@/util/models';
import Kota from './Kota';

export default class Kecamatan extends Model { 
    backend = '/master/kecamatan/'; 
    
    getKota(){       
        let kota = new Kota;
        return kota.all();        
    } 
}

